module.exports = {
  VWC_ENROLLMENT_NOTIFICATION: 'VWC_ENROLLMENT_NOTIFICATION'
};